/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Link,
  Drawer,
  Divider,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { usePersistentState } from "../../contexts/global-context";
import { GetLocalStorage } from "../../utils/local-storage";
import Iconify from "../iconify/Iconify";
import Color from "../../theme/color";

const TopTabBar = ({
  backgroundColors,
  textColor,
  boxShadow,
  iconColor,
  event,
}: any) => {
  const navigate = useNavigate();
  const [state]: any = usePersistentState();
  const [loginInfo, setLoginInfo] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState("transparent");
  const [, setBoxShadows] = useState("none");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
    navigate("/login");
  };

  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
  }, [state.users]);

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };
  const smoothScroll = (target: string) => {
    const $target = document.querySelector(target);
    if ($target) {
      window.scrollTo({
        top: $target.getBoundingClientRect().top + window.pageYOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;
      if (position > 0) {
        setBackgroundColor("#2f3138");
        setBoxShadows("0px 3px 5px rgba(0, 0, 0, 0.2)");
      } else {
        setBackgroundColor(backgroundColors);
        setBoxShadows("none");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [backgroundColors]);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };
  const handleHomeClick = () => {
    toggleDrawer();
    navigate("/home");
    smoothScroll("#home");
  };
  return (
    <AppBar style={{ backgroundColor, boxShadow, position: "fixed" }}>
      <Toolbar>
        <Link
          onClick={() => {
            navigate("/home");
          }}
          style={{ textDecoration: "none", marginTop: 5 }}
          component="button"
        >
          <img
            style={{ height: " 47.3px", width: "110px", margin: 10 }}
            src={require("../../assets/image/eventprix-logo-main.png")}
          />
        </Link>
        <div style={{ flexGrow: 17 }} />
        <Box
          sx={{
            flexGrow: 1,
            display: { xs: "flex", md: "none" },
            marginRight: 1,
          }}
        >
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={toggleDrawer}
            color={iconColor}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
            sx={{
              display: { xs: "block", md: "none" },
            }}
          >
            {loginInfo === null ? (
              <div
                style={{
                  flexDirection: "column",
                }}
              >
                <Drawer
                  anchor="top"
                  open={drawerOpen}
                  onClose={toggleDrawer}
                  transitionDuration={600}
                >
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    <Box
                      sx={{
                        marginLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Iconify
                        sx={{
                          color: Color.primary,
                          marginBottom: "3px",
                          marginRight: "5px",
                          width: "23px !important",
                          height: "23px !important",
                        }}
                        icon="tabler:home"
                      />
                      <Button
                        variant="text"
                        onClick={handleHomeClick}
                        sx={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "300",
                        }}
                      >
                        Home
                      </Button>
                    </Box>
                    <Divider />
                    <a
                      style={{
                        marginLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={(e: any) => {
                        e.preventDefault();
                        smoothScroll("#hostbenefits");
                        toggleDrawer();
                      }}
                    >
                      <Iconify
                        sx={{
                          color: Color.primary,
                          marginRight: "5px",
                          width: "23px !important",
                          height: "23px !important",
                        }}
                        icon="streamline:give-gift"
                      />
                      <Button
                        variant="text"
                        onClick={() => {
                          navigate(`/home`);
                        }}
                        sx={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "300",
                        }}
                      >
                        Host Benefits
                      </Button>
                    </a>
                    <Divider />
                    {/* mobile view */}
                    <Box
                      sx={{
                        marginLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Iconify
                        sx={{
                          color: Color.primary,
                          marginRight: "5px",
                          width: "23px !important",
                          height: "23px !important",
                        }}
                        icon="gridicons:create"
                      />
                      <Button
                        variant="text"
                        // onClick={() => {
                        //   navigate("/dashboard/event/add");
                        // }}
                        onClick={() => {
                          navigate("/login");
                        }}
                        sx={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "300",
                        }}
                      >
                        Create Event
                      </Button>
                    </Box>
                    <Divider />
                    <Box
                      sx={{
                        marginLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Iconify
                        sx={{
                          color: Color.primary,
                          marginRight: "5px",
                          width: "23px !important",
                          height: "23px !important",
                        }}
                        icon="ic:round-login"
                      />
                      <Button
                        variant="text"
                        sx={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "300",
                        }}
                        onClick={() => {
                          navigate(`/login`);
                        }}
                      >
                        Sign In
                      </Button>
                    </Box>
                    <Divider />
                    <Box
                      sx={{
                        marginLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Iconify
                        sx={{
                          color: Color.primary,
                          marginRight: "5px",
                          width: "23px !important",
                          height: "23px !important",
                        }}
                        icon="pixelarticons:contact-plus"
                      />
                      <Button
                        variant="text"
                        sx={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "300",
                        }}
                        onClick={() => {
                          navigate(`/signup`);
                        }}
                      >
                        Sign Up
                      </Button>
                    </Box>
                    <Divider />
                  </div>
                </Drawer>
              </div>
            ) : (
              <div>
                <Drawer
                  anchor="top"
                  open={drawerOpen}
                  onClose={toggleDrawer}
                  transitionDuration={600}
                >
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    <Box
                      sx={{
                        marginLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Iconify
                        sx={{
                          color: Color.primary,
                          width: "23px !important",
                          height: "23px !important",
                          marginBottom: "5px",
                        }}
                        icon="tabler:home"
                      />
                      <Button
                        variant="text"
                        onClick={handleHomeClick}
                        sx={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "300",
                        }}
                      >
                        Home
                      </Button>
                    </Box>
                    <Divider />
                    <Box
                      sx={{
                        marginLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Iconify
                        sx={{
                          color: Color.primary,
                          width: "23px !important",
                          height: "23px !important",
                        }}
                        icon="icon-park-outline:sales-report"
                      />
                      <Button
                        variant="text"
                        onClick={() => {
                          navigate("/dashboard");
                        }}
                        sx={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "300",
                        }}
                      >
                        Dashboard
                      </Button>
                    </Box>
                    <Divider />
                    <a
                      style={{
                        marginLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={(e: any) => {
                        e.preventDefault();
                        smoothScroll("#hostbenefits");
                        toggleDrawer();
                      }}
                    >
                      <Iconify
                        sx={{
                          color: Color.primary,
                          width: "23px !important",
                          height: "23px !important",
                        }}
                        icon="streamline:give-gift"
                      />
                      <Button
                        variant="text"
                        onClick={() => {
                          navigate(`/home`);
                        }}
                        sx={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "300",
                        }}
                      >
                        Host Benefits
                      </Button>
                    </a>
                    <Divider />
                    <Box
                      sx={{
                        marginLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Iconify
                        sx={{
                          color: Color.primary,
                          width: "23px !important",
                          height: "23px !important",
                        }}
                        icon="gridicons:create"
                      />
                      <Button
                        variant="text"
                        onClick={() => {
                          navigate("/dashboard/event/add");
                        }}
                        sx={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "300",
                        }}
                      >
                        Create Event
                      </Button>
                    </Box>

                    <Divider />
                    <Box
                      sx={{
                        marginLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Iconify
                        sx={{
                          color: Color.primary,
                          width: "23px !important",
                          height: "23px !important",
                        }}
                        icon="mdi:logout"
                      />
                      <Button
                        variant="text"
                        sx={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "300",
                        }}
                        onClick={handleLogout}
                      >
                        Logout
                      </Button>
                    </Box>
                  </div>
                </Drawer>
              </div>
            )}
          </Menu>
        </Box>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
          }}
        >
          {loginInfo === null ? (
            <>
              <Button
                onClick={(e) => {
                  navigate("/home");
                  e.preventDefault();
                  smoothScroll("#home");
                }}
                sx={{
                  color: textColor,
                  display: "flex",
                  alignItems: "center",
                  fontSize: 16,
                  marginLeft: 2,
                  fontWeight: 600,
                }}
              >
                Home
              </Button>
              <Button
                sx={{
                  color: textColor,
                  display: "flex",
                  alignItems: "center",
                  fontSize: 16,
                  marginLeft: 2,
                  fontWeight: 600,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  smoothScroll("#eventin");
                }}
              >
                Events
              </Button>
              <a
                onClick={(e: any) => {
                  e.preventDefault();
                  smoothScroll("#hostbenefits");
                }}
              >
                <Button
                  onClick={() => {
                    navigate(`/home`);
                  }}
                  sx={{
                    color: textColor,
                    display: "flex",
                    alignItems: "center",
                    fontSize: 16,
                    marginLeft: 2,
                    fontWeight: 600,
                  }}
                >
                  Host Benefits

                </Button>
              </a>
     {/* fullscreen */}
              <Button
                onClick={() => {
                  navigate("/login");
                }}
                sx={{
                  color: textColor,
                  display: "flex",
                  alignItems: "center",
                  fontSize: 16,
                  marginLeft: 2,
                  fontWeight: 600,
                }}
              >
                Create Event
              </Button>

              <Button
                onClick={() => {
                  navigate("/login");
                }}
                sx={{
                  color: textColor,
                  display: "flex",
                  alignItems: "center",
                  fontSize: 16,
                  marginLeft: 2,
                  fontWeight: 600,
                }}
              >
                Sign In
              </Button>
              <Button
                sx={{
                  color: textColor,
                  display: "flex",
                  alignItems: "center",
                  fontSize: 16,
                  marginLeft: 2,
                  fontWeight: 600,
                }}
                onClick={() => {
                  navigate("/signup");
                }}
              >
                Sign Up
              </Button>
            </>
          ) : (
            <>
              <a
                onClick={(e: any) => {
                  e.preventDefault();
                  smoothScroll("#home");
                }}
              >
                <Button
                  onClick={() => {
                    navigate("/home");
                  }}
                  sx={{
                    color: textColor,
                    display: "flex",
                    alignItems: "center",
                    fontSize: 16,
                    marginLeft: 2,
                    fontWeight: 600,
                  }}
                >
                  Home
                </Button>
              </a>
              <Button
                onClick={() => {
                  navigate("/dashboard");
                }}
                sx={{
                  color: textColor,
                  display: "flex",
                  alignItems: "center",
                  fontSize: 16,
                  marginLeft: 2,
                  fontWeight: 600,
                }}
              >
                Dashboard
              </Button>
              <a
                onClick={(e: any) => {
                  e.preventDefault();
                  smoothScroll("#hostbenefits");
                }}
              >
                <Button
                  onClick={() => {
                    navigate(`/home`);
                  }}
                  sx={{
                    color: textColor,
                    display: "flex",
                    alignItems: "center",
                    fontSize: 16,
                    marginLeft: 2,
                    fontWeight: 600,
                  }}
                >
                  Host Benefits
                </Button>
              </a>
              <Button
                onClick={() => {
                  navigate("/dashboard/event/add");
                }}
                sx={{
                  color: textColor,
                  display: "flex",
                  alignItems: "center",
                  fontSize: 16,
                  marginLeft: 2,
                  fontWeight: 600,
                }}
              >
                Create Event
              </Button>
              <Button
                sx={{
                  color: textColor,
                  display: "flex",
                  alignItems: "center",
                  fontSize: 16,
                  marginLeft: 2,
                  fontWeight: 600,
                }}
                onClick={() => {
                  navigate(`/contact-us`);
                }}
              >
                Contact Us
              </Button>
              <Button
                sx={{
                  color: textColor,
                  display: "flex",
                  alignItems: "center",
                  fontSize: 16,
                  marginLeft: 2,
                  fontWeight: 600,
                }}
                onClick={handleLogout}
              >
                Logout
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopTabBar;
